import { Stack } from 'expo-router';

export default function AppSegmentLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="(tabs)" />
      <Stack.Screen name="events" />
      <Stack.Screen name="check-in/[id]" />
      <Stack.Screen name="clubs" />
      <Stack.Screen name="members/[id]" />
      <Stack.Screen name="profile/edit" />
      <Stack.Screen name="integrations" />
      <Stack.Screen name="settings/account" />
      <Stack.Screen name="settings/integrations" />
    </Stack>
  );
}
